import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './store/auth.ts';
import { AppShell } from './components/layout/AppShell.tsx';
import { ToastHost } from './components/common/ToastHost.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { SignupPage } from './pages/SignupPage.tsx';
import { FilesPage } from './pages/FilesPage.tsx';
import { TrashPage } from './pages/TrashPage.tsx';
import { RecentPage } from './pages/RecentPage.tsx';
import { SharedPage } from './pages/SharedPage.tsx';
import { SharedDrivePage } from './pages/SharedDrivePage.tsx';
import { AdminPage } from './pages/AdminPage.tsx';
import { DevicesPage } from './pages/DevicesPage.tsx';
import { AccountPage } from './pages/AccountPage.tsx';
import { PublicLinkPage } from './pages/PublicLinkPage.tsx';
import { DownloadPage } from './pages/DownloadPage.tsx';

/** 공유 기능이 꺼져 있으면 관련 화면 대신 내 드라이브로 보낸다 */
function SharingGate({ children }: { children: React.ReactNode }) {
  const sharing = useAuth((s) => s.features.sharing);
  if (!sharing) return <Navigate to="/files" replace />;
  return <>{children}</>;
}

function Loading() {
  return (
    <div className="auth">
      <div className="row"><span className="spinner" /> 불러오는 중…</div>
    </div>
  );
}

export function App() {
  const status = useAuth((s) => s.status);
  const bootstrap = useAuth((s) => s.bootstrap);

  useEffect(() => { void bootstrap(); }, [bootstrap]);

  return (
    <>
      <Routes>
        {/* 공개 링크와 클라이언트 다운로드는 로그인 없이 접근할 수 있어야 한다 */}
        <Route path="/s/:token" element={<PublicLinkPage />} />
        <Route path="/download" element={<DownloadPage />} />

        {status === 'loading' && <Route path="*" element={<Loading />} />}

        {status === 'anonymous' && (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}

        {status === 'authenticated' && (
          <Route element={<AppShell />}>
            <Route path="/files/*" element={<FilesPage />} />
            <Route path="/recent" element={<RecentPage />} />
            <Route path="/shared" element={<SharingGate><SharedPage /></SharingGate>} />
            <Route path="/ns/:nsId/*" element={<SharingGate><SharedDrivePage /></SharingGate>} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/trash" element={<TrashPage />} />
            <Route path="/devices" element={<DevicesPage />} />
            <Route path="/account" element={<AccountPage />} />
            {/* 예전 경로 호환 */}
            <Route path="/settings" element={<Navigate to="/account" replace />} />
            <Route path="*" element={<Navigate to="/files" replace />} />
          </Route>
        )}
      </Routes>
      <ToastHost />
    </>
  );
}
